<!--
출력방식 변경
-->
<template>
    <div class="block-overlay" ref="block-overlay" v-show="display">
        <div class="block-dialog w-40rem text-black">

            <!-- 로딩중 -->
            <div v-if="status === 'loading'" class="p-1rem"><loading-icon></loading-icon>Finding All PrintTypes...</div>

            <!-- 결과 -->
            <div v-if="status === 'loaded'" class="">
                <div class="uk-flex uk-flex-middle uk-flex-between border-b border-b-gray">
                    <div class="p-1rem font-bold font-size-1d125rem">사용할 출력방식을 선택하세요.</div>
                    <a class="uk-link-reset p-0d5rem" title="close" @click="hide"><i class="material-icons font-size-1d5rem">close</i></a>

                </div>

                <div class="p-2rem">
                    <div
                        v-for="(printType, index) in printTypes"
                        :key="index"
                        class="border-b border-b-gray-200 p-0d5rem font-size-1d125rem mb-1rem"
                    >
                        <button
                            type="button"
                            class="uk-button uk-button-small uk-button-white mr-1rem"
                            @click="usePrintType(printType)"
                        ><i class="material-icons">check</i>선택</button>


                        <span v-if="printType === 'pdf'">PDF</span>
                        <span v-if="printType === 'zpl'">(구방식) ZPL</span>
                        <span v-if="printType !== 'pdf' && printType !== 'zpl' ">{{ printType }}</span>



                    </div>


                    <div class="uk-text-center">
                        <button
                            type="button"
                            class="uk-button uk-button-small uk-button-gray"
                            @click="hide"
                        >
                            <i class="material-icons font-size-1d5rem">close</i>
                            취소
                        </button>
                    </div>
                </div>

            </div>

        </div>
    </div>
</template>

<script>

// 프린터 관리객체
import {get_printer} from "../../../../classes/printer-manager";
import LoadingIcon from "../../common/loading-icon.vue";

export default {
    components: {LoadingIcon},
    props: {},
    data: function () {
        return {
            // (int) 지역ID
            regionId: null,

            // (bool) 폼 display 여부
            display: false,

            // (Object) 프린터정보
            printer: null,

            // (null|string) 로딩상태 (null: 실행전, loading: 로딩중, loaded: 로딩완료)
            status: null,

            // (array)
            printTypes: [],
        };
    },
    computed: {},
    mounted() {
    },
    methods: {

        /**
         * 폼 띄우기
         */
        form(region_id) {
            // 데이터 초기화
            this.regionId = region_id;
            this.status = null;
            this.printTypes = [];

            // 프린터객체
            this.printer = get_printer(this.regionId);

            // 폼띄우기
            // 컨펌 엘리먼트 body 밑으로 이동
            document.body.appendChild(this.$refs['block-overlay']);
            this.display = true;

            // 목록 불러오기
            this.findPrintTypes();
        },

        /**
         * QZ에서 목록 불러오기
         */
        findPrintTypes() {
            this.status = 'loading';


            this.printTypes = this.printer.getAblePrintTypes();
            this.status = 'loaded';
        },

        /**
         * 선택한  사용설정
         */
        usePrintType(type) {
            this.printer.usePrintType(type).then((data) => {
                this.hide();

            }).catch((err) => {
                alert(err);

            });
        },


        /**
         * 폼 hide
         */
        hide() {
            this.display = false;
        },
    },// end methods
}
</script>

<style lang="scss" scoped>
// 컨펌화면
.block-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.7);
    z-index: 9999;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .block-dialog {
        max-width: 90%;
        max-height: 70%;
        background-color: #fff;

        overflow-y: auto;

    }
}
</style>